/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";
import { REQUIRED_VALIDATION_MESSAGE } from "./constants";

export const schema = yup.object().shape({
  provider: yup.string(),
  providerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  displayName: yup.string(),
  description: yup.string(),
  contactIds: yup.array().of(yup.string()),
  orgUnitIds: yup.array().of(yup.string()),
});

export const schemaCredsAWS = yup.object().shape({
  externalId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  arn: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  providerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  displayName: yup.string(),
  ownerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  contactIds: yup.string(),
});

export const schemaCredsAzure = yup.object().shape({
  appId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  password: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  tenantId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  providerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  displayName: yup.string(),
  ownerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  contactIds: yup.string(),
});

export const schemaCredsHybrid = yup.object().shape({
  ownerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  clusterName: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
});

export const schemaCredsIbmcloud = yup.object().shape({
  ownerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  appKey: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
  providerId: yup.string().required(REQUIRED_VALIDATION_MESSAGE),
});
